import { render, staticRenderFns } from "./UberMenuCopy.vue?vue&type=template&id=733c4a8f&scoped=true"
import script from "./UberMenuCopy.vue?vue&type=script&lang=js"
export * from "./UberMenuCopy.vue?vue&type=script&lang=js"
import style0 from "./UberMenuCopy.vue?vue&type=style&index=0&id=733c4a8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733c4a8f",
  null
  
)

export default component.exports